import { CurrentUser } from './CurrentUser.ts';
import { PostHogService } from '../../services/posthogService.ts';

export function rememberSignedInUser(currentUser: CurrentUser) {
    localStorage.setItem('currentUser', JSON.stringify(currentUser));
    const distinctId = currentUser.patientID || currentUser.healthcareProfessionalID;
    const userRole = currentUser.patientID ? 'patient' : 'hcp';
    PostHogService.identify(distinctId, {
        display_name: currentUser.displayName,
        language: currentUser.language,
        user_role: userRole,
        environment: import.meta.env.MODE,
    });
    PostHogService.capture('user logged in', {
        user_role: userRole,
        language: currentUser.language,
    });
}
